import React, { Component } from "react";
import PropTypes from "prop-types";

//import { TTP_PORTAL_URL, TTP_HOME_URL } from "Config";
import { logout } from "Utils";

export function checkAuthentication(component) {
  return class AuthenticatedRoute extends Component {
    static contextTypes = {
      store: PropTypes.object,
      router: PropTypes.object
    };

    componentWillMount() {
      const {
        store,
        router: { route }
      } = this.context;

      const { auth } = store.getState();

      if (!auth || !auth.user) {
        const {
          location: { pathname }
        } = route;

        logout(pathname.substr(1));

        //const goto = encodeURI(TTP_PORTAL_URL + pathname.substr(1));
        //window.location.assign(`${TTP_HOME_URL}?goto=${goto}`);
      }
    }

    render() {
      return React.createElement(component, { ...this.props });
    }
  };
}



// WEBPACK FOOTER //
// ./src/router/checkAuthentication.js